var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7085 9.37516V7.29183C17.7085 6.7393 17.489 6.20939 17.0983 5.81869C16.7076 5.42799 16.1777 5.2085 15.6252 5.2085H4.16683C3.6143 5.2085 3.08439 5.42799 2.69369 5.81869C2.30299 6.20939 2.0835 6.7393 2.0835 7.29183V17.7085C2.0835 18.261 2.30299 18.7909 2.69369 19.1816C3.08439 19.5723 3.6143 19.7918 4.16683 19.7918H15.6252C16.1777 19.7918 16.7076 19.5723 17.0983 19.1816C17.489 18.7909 17.7085 18.261 17.7085 17.7085V15.6252L22.9168 19.7918V5.2085L17.7085 9.37516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.4628a348f3b78b3cc5e2a0ab38f9c9b5.svg";
export { ForwardRef as ReactComponent };